import {formatTime} from '@/config/mUtils'

const vueFilter={
  publicFormatTime:(value)=>{
    return value ?formatTime(value,'yyyy-mm-dd hh:ii:ss'):'';
  },
  BatchModify:(value)=>{
    switch (value) {
      case 'batch_number':
        return "删除批次号";
      case 'waybill_no':
        return "删除运单号";
      case 'frame_number':
        return "删除车架号";
      case 'lock_plan':
        return "锁定计划";
      case 'lock_vehicle':
        return "锁定运输车";
      case 'Unlock_plan':
        return "解锁计划";
      case 'Unlock_vehicle':
        return "解锁运输车";


    }
  },
  workTypeFormat:(value)=>{
    switch (value) {
      case 1:
        return '装船';
      case 2:
        return '卸船';
      case 3:
        return '过驳';
    }
  },
}
export default vueFilter
